import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Studio from "@/pages/Studio";
import MyDogs from "@/pages/MyDogs";
import SharedPreview from "@/pages/SharedPreview";
import { StripeSuccess, StripeCancel } from "@/pages/PaymentReturn";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/studio" element={<Studio />} />
          <Route path="/dogs" element={<MyDogs />} />
          <Route path="/p/:id" element={<SharedPreview />} />
          <Route path="/payment/success" element={<StripeSuccess />} />
          <Route path="/payment/cancel" element={<StripeCancel />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#ffffff",
            color: "#0f172a",
            border: "1px solid #eae4d9",
          },
        }}
      />
    </div>
  );
}

export default App;
